import LcapLogin from './index.vue';

export {
    LcapLogin,
};

export default LcapLogin;
